import type { ImageModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { AssetModifier } from "./base/AssetModifier";
import BorderModifier from "./base/BorderModifier";
import HeightModifier from "./base/HeightModifier";
import MarginModifierComponent from "./base/MarginModifier";
import ProductSelectorModifier from "./base/ProductSelectorModifier";
import ShadowModifierComponent from "./base/ShadowModifier";
import WidthModifier from "./base/WidthModifier";
import ModifierLayout from "./ModifierLayout";
import { useSelectedElement } from "./store/ModifiersStoreContext";

interface ImageModifierBlockProps {
  onModifiersValueChange: (modifiers: ImageModifierValue[]) => void;
}

const ImageModifierBlock: React.FC<ImageModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const selectedElement = useSelectedElement();

  const sections = [
    ...(selectedElement?.props?.productId
      ? [
          {
            rows: [
              {
                title: "Product",
                component: (
                  <ProductSelectorModifier onChange={onModifiersValueChange} />
                ),
              },
            ],
          },
        ]
      : []),
    {
      rows: [
        {
          title: "Media",
          component: (
            <AssetModifier
              onAssetChange={(assetSource) => {
                onModifiersValueChange([
                  { type: "asset", source: assetSource ?? "" },
                ]);
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Width",
          component: <WidthModifier onChange={onModifiersValueChange} />,
        },
        {
          title: "Height",
          component: <HeightModifier onChange={onModifiersValueChange} />,
        },
      ],
    },
    {
      rows: [
        {
          title: "Margin",
          component: (
            <MarginModifierComponent onChange={onModifiersValueChange} />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Border",
          component: <BorderModifier onChange={onModifiersValueChange} />,
        },
        {
          title: "Shadow",
          component: (
            <ShadowModifierComponent onChange={onModifiersValueChange} />
          ),
        },
      ],
    },
  ];

  return <ModifierLayout sections={sections} />;
};

export default ImageModifierBlock;
